import {
  Avatar, Flexbox, ListManager, PageHeader, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import documentNumberMask from '@/lib/masks/documentNumber'
import reports from '@/services/api/reports'
import React from 'react'
import FilterClinicalCares from '../../components/FilterClinicalCares'
import CardItem from '../components/CardItem'

function ClinicalCaresByClinic({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(reports.clinicalCaresByClinic, query)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Atendimentos clínicos por clínica"
        subtitle="Quantidade de atendimentos clínicos por clínica"
        icon="fas fa-clinic-medical"
        rightAction={() => <FilterClinicalCares />}
      />
      <ListManager count={data?.rows?.length || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <Flexbox.Columns>
            {data.rows.map((item) => (
              <Flexbox.Column key={item?.clinicId || 'without-clinic'} className="col-6 col-sm-12 my-2">
                <CardItem
                  item={item}
                  statusList={data?.statusList}
                  header={(
                    <Flexbox.Columns className="align-center col-gapless">
                      {Boolean(item?.fullName) && (
                        <Flexbox.Column className="col-auto">
                          <Avatar
                            avatarSize="lg"
                            name={item?.fullName}
                            photoURL={item?.photoURL}
                            alt="Imagem da clínica"
                          />
                        </Flexbox.Column>
                      )}
                      <Flexbox.Column className="ml-2">
                        <b>{item?.fullName || 'Atendimentos sem clínica'}</b>
                        {Boolean(item?.documentNumber) && (
                          <div>
                            <small>{documentNumberMask(item?.documentNumber)}</small>
                          </div>
                        )}
                      </Flexbox.Column>
                    </Flexbox.Columns>
                  )}
                />
              </Flexbox.Column>
            ))}
          </Flexbox.Columns>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default ClinicalCaresByClinic
